import * as bbpf from "../../../bbpf";
import 'kbw-countdown/dist/js/jquery.plugin.js';
import 'kbw-countdown/dist/js/jquery.countdown.js';
import '../../layout';

document.addEventListener("DOMContentLoaded",function(e) {
    const data = document.getElementById('main'),
        folder_data = data.getAttribute('data-folder'),
        url = data.getAttribute('data-folder-url'),
        folder = new bbpf.Folder(folder_data),
        pagination = new bbpf.Pagination({
            limit: 9
        }),
        folder_browser = new bbpf.FolderController({
            url : url,
            folder : folder_data,
            components : {
                main : new bbpf.Component({
                    container : document.getElementById('content')
                }),
                pagination : new bbpf.PaginationComponent({
                    container : document.getElementById('pagination'),
                    pagination : pagination
                })
            },
            parameters : {
                display : 'event_summary',
                limit : pagination.get('limit'),
                filter_types: ['event']
            }
        });

    pagination.dispatcher.add('pagination_change', function() {
        folder_browser.refresh({
            limit: this.get('limit'),
            offset: this.get('offset')
        });
    });

    folder_browser.load();

    folder_browser.dispatcher.add('after_load_success', function(p) {
        for (const el of document.querySelectorAll('.defaultCountdown')) {
            const starts_date = el.getAttribute('data-starts'),
                austDay = new Date(starts_date);

            jQuery(el).countdown({
                until: austDay
            });
            //$('#year').text(austDay.getFullYear());
        }
    });

});
